export const PAYPAL_POLL_INTERVAL_MS = (() => {
  const envValue = typeof process !== 'undefined' && process.env ? process.env.PAYPAL_POLL_INTERVAL_MS : undefined
  const windowValue = typeof window !== 'undefined' && window.PAYPAL_POLL_INTERVAL_MS
  const defaultValue = 5000

  const value = parseInt(envValue || windowValue || defaultValue, 10)

  if (Number.isNaN(value) || value < 1000) {
    console.warn('PayPal poll interval is invalid or too short, using default of 5000ms')
    return defaultValue
  }

  return value
})()

export const PAYPAL_POLL_TIMEOUT_MS = (() => {
  const envValue = typeof process !== 'undefined' && process.env ? process.env.PAYPAL_POLL_TIMEOUT_MS : undefined
  const windowValue = typeof window !== 'undefined' && window.PAYPAL_POLL_TIMEOUT_MS
  const defaultValue = 180000 // 3 minutes (180 seconds)

  const value = parseInt(envValue || windowValue || defaultValue, 10)

  if (Number.isNaN(value) || value < PAYPAL_POLL_INTERVAL_MS) {
    console.warn('PayPal poll timeout is invalid or less than interval, using interval * 18')
    return PAYPAL_POLL_INTERVAL_MS * 18
  }

  return value
})()
